<template>
  <div class="about container">
    <div></div>
    <div>
      <h4 class="part-title">{{aboutInfo.aboutHeading}}</h4>
      <h3>{{aboutInfo.aboutTitle}}</h3>
      <p>{{aboutInfo.aboutText}}</p>
      <ShowMore :info="info" class="blue" :class="info.class"></ShowMore>
    </div>
  </div>
</template>
<script>
const ShowMore = () => import("@/components/shared/Show_more");
export default {
  data() {
    return {
      info: {
        url: "/about",
        text: "Read More",
        class: "line-end",
      },
    };
  },
  computed: {
    aboutInfo() {
      var slider = JSON.parse(JSON.stringify(this.$store.getters.homePage));
      return slider;
    },
  },
  components: {
    ShowMore,
  },
};
</script>
<style lang="scss" scoped>
.about {
  padding: 15.5rem 0 16.5rem;
  @media only screen and (max-width: 992px) {
    padding: 8rem 0;
  }
  &.container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    @media only screen and (max-width: 992px) {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    @media (max-height: 499px) and (max-width: 899px), (max-width: 767px) {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
    }
  }
  & > div {
    width: 59%;
    @media only screen and (max-width: 992px) {
      width: 45%;
    }
    @media (max-height: 499px) and (max-width: 899px), (max-width: 767px) {
      width: 100%;
    }
    &:first-of-type {
      background-image: url("../../assets/img/logo.svg");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      height: 0;
      padding-top: 27%;
      margin-left: -4rem;
      @media only screen and (max-width: 992px) {
        margin-left: 0;
      }
      @media (max-height: 499px) and (max-width: 899px), (max-width: 767px) {
        padding-top: 45%;
        margin: 0 0 5rem;
      }
    }
    &:last-of-type {
      width: 40%;
      padding-right: 5rem;
      padding-top: 1.5rem;
      h3 {
        font-size: 4rem;
        line-height: 4.5rem;
        margin-bottom: 1.5rem;
      }
      p {
        margin-bottom: 3rem;
      }
      @media only screen and (max-width: 992px) {
        width: 55%;
        padding: 0 2rem 0;
      }
      @media (max-height: 499px) and (max-width: 899px), (max-width: 767px) {
        width: 100%;
        padding: 0;
        h3 {
          font-size: 3.5rem;
          line-height: 4rem;
        }
      }
    }

    p {
      margin-bottom: 3.5rem;
    }
  }
}
</style>